export default __webpack_public_path__ + "static/media/CompoundWords_15.f9e6e8e5.png";